import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/documents/list`
        );
        setDocuments(response.data.data);
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveDocument = async (id, title) => {
    if (
      window.confirm(`Are you sure you want to delete this document: ${title}?`)
    ) {
      try {
        setError(null);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/documents/archive/id/${id}`
        );
        setDocuments(documents.filter((event) => event.id !== id));
        toast.success(`${title} Document deleted successfully`, {
          theme: 'colored',
        });
      } catch (error) {
        setError(error.message);
      }
    }
  };

  return (
    <>
      <PageHeader
        title='Documents List'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th scope='col'>Date Added</th>
              <th scope='col'>Category</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {documents.map((doc, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/document/${doc.id}`}>{doc.title}</Link>
                </td>
                <td>{doc.date_added}</td>
                <td>{doc.category}</td>
                <td className='text-end'>
                  <Link to={`/documents/edit/${doc.id}`}>
                    <ActionButton
                      icon='edit'
                      title='Edit'
                      variant='action'
                      className='p-0 me-2'
                      alt='Edit'
                    />
                  </Link>
                  <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    alt='Delete'
                    onClick={() => archiveDocument(doc.id, doc.title)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListDocuments;
